var _defs, _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMapLoadSelect(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1 {\r\n        fill-rule: evenodd;\r\n      }\r\n\r\n      .cls-1, .cls-2, .cls-3, .cls-4 {\r\n        stroke-width: 0px;\r\n      }\r\n\r\n      .cls-1, .cls-3 {\r\n        fill: #fff;\r\n      }\r\n\r\n      .cls-2 {\r\n        fill: #076607;\r\n      }\r\n\r\n      .cls-4 {\r\n        fill: #04bc04;\r\n      }\r\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M12,1.1c-3.8,0-6.9,3.1-6.9,6.9s3.1,6.9,6.9,6.9c3.8,0,6.9-3.1,6.9-6.9,0-3.8-3.1-6.9-6.9-6.9Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M15.8,1C14.6.3,13.3,0,12,0c-4.4,0-8,3.6-8,8,0,1.3.3,2.6,1,3.8l6.6,11.9c.1.2.4.3.7.2,0,0,.1-.1.2-.2l6.5-11.9c2.1-3.9.6-8.7-3.2-10.8ZM12,14.9c-3.8,0-6.9-3.1-6.9-6.9S8.2,1.1,12,1.1s6.9,3.1,6.9,6.9c0,3.8-3.1,6.9-6.9,6.9Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M16.8,10.5h-.5c-.2-.1-.4-.2-.6-.2h1.1v-.6h-5.3v-5.3h5.3v-.6h-5.9v6.6h2.4v.2h-.7v.9h.1l-1.5.3v-.2h-.3v.8h.3v-.2l1.7-.4h.8v.4h.3c0,.3.2.6.4.8.3.3.6.4,1,.4s.7-.2,1-.4c.2-.2.3-.5.4-.8h0v-1.6h0ZM15.4,12.6c-.4,0-.7-.3-.7-.7s.3-.7.7-.7.7.3.7.7-.3.7-.7.7Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M8.8,4.1v1.1h-2.4c-.2,0-.4.2-.4.4s.2.4.4.4h2.4v1.1c0,.2.1.3.3.1l1.5-1.6-1.5-1.6c-.1-.1-.3-.1-.3.1h0s0,0,0,0Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M8.8,8v1.1h-2.4c-.2,0-.4.2-.4.4s.2.4.4.4h2.4v1.1c0,.2.1.3.3.1l1.5-1.6-1.5-1.6c-.1-.1-.3-.1-.3.1h0s0,0,0,0Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMapLoadSelect);
export default __webpack_public_path__ + "static/media/map-load-select.e2e9179a0a727d0e77593cb7259c7f43.svg";
export { ForwardRef as ReactComponent };